var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors.length)?_c('div',{staticClass:"errors"},[_c('div',_vm._l((_vm.errors),function(error,idx){return _c('div',{key:idx},[_vm._v(" "+_vm._s(error)+" ")])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }